import ImageEvaluationList from '../../modules/ImageEvaluation/ImageEvaluationList/imageEvaluationList'

export default function ImageEvaluationScreen() {
    
    return (
        <>
            <ImageEvaluationList/>
        </>
    );
}